import { render, staticRenderFns } from "./ProvisionForm.vue?vue&type=template&id=a50bfa76&scoped=true&"
import script from "./ProvisionForm.vue?vue&type=script&lang=js&"
export * from "./ProvisionForm.vue?vue&type=script&lang=js&"
import style0 from "./ProvisionForm.vue?vue&type=style&index=0&id=a50bfa76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50bfa76",
  null
  
)

export default component.exports